module.exports = __webpack_public_path__ + "img/background.65c6a137.jpg";